import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';

import { getUserToken } from '@/shared/services/user-hash';
import { MainLoader } from '@/shared/ui';
import { useAppDispatch } from '@/store';
import { getOptimizedDictionaries } from '@/store/dict.slice';
import {
  getUserAccount,
  getUserMenu,
  setJwtDecodedInfo
} from '@/store/user-info.slice';

const AuthorizedProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      dispatch(setJwtDecodedInfo(jwtDecode(getUserToken().accessToken)));
      await Promise.all([
        dispatch(getUserAccount()),
        dispatch(getUserMenu()),
        dispatch(getOptimizedDictionaries())
      ]);
      setIsLoading(false);
    })();
  }, [dispatch]);

  return isLoading ? <MainLoader fullScreen={true} /> : children;
};

export default AuthorizedProvider;
